import "./utils/authSessionBootstrap";
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import "styles/design-tokens.css";
import "styles/scrollbars.css";
import "styles/dropdowns.css";
import "styles/search-inputs.css";
import "styles/form-fields.css";
import "styles/documentPreview.css";
import "styles/number-inputs.css";
import "components/Skeleton/skeleton.css";
import { installNumberInputConstraints } from "utils/numberInputConstraints";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { store } from "Store/store";
let persistor = persistStore(store);

installNumberInputConstraints();

ReactDOM.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </MaterialUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
